import { render } from "./WaiterModal.vue?vue&type=template&id=3f54db00&scoped=true"
import script from "./WaiterModal.vue?vue&type=script&lang=js"
export * from "./WaiterModal.vue?vue&type=script&lang=js"

import "./WaiterModal.vue?vue&type=style&index=0&id=3f54db00&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f54db00"]])

export default __exports__